import { useAuth } from "../auth/auth-context";
import ChannelListing from "../sendbird-chat/channel-listing";

interface ChatListProps {
  currentChannelUrl: string | null;
  onSelectChat: (channelUrl: string) => void;
}

export const ChatList = ({
  currentChannelUrl,
  onSelectChat,
}: ChatListProps) => {
  const { user } = useAuth();

  return (
    <div className="h-full">
      <ChannelListing
        customTypesFilter={["SUPERVISION"]}
        currentChannelUrl={currentChannelUrl}
        setCurrentChannelUrl={onSelectChat}
        showRoleBadge={true}
        disableAutoSelect={user?.role !== "MENTOR"} // Auto select the first channel if the user is a mentor
        shouldEverShowCheckinBadge={false} // We don't want to show the check-in badge in the floating chat list
      />
    </div>
  );
};
